<template>
<div class="ActivityGoodsEdit">
    <goodsEdit></goodsEdit>
</div>
</template>

<script>
import GoodsEdit from 'views/brandBusiness/systemSetting/goodsBack/GoodsEdit.vue'
export default {
    name: 'ActivityGoodsEdit',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        GoodsEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityGoodsEdit {
}
</style>
